<template>
  <div :id="uuid" :style="{width:width+'px',height:height+'px'}"/>
</template>

<script setup>
import {getDataJson, pollingRefresh,hasNonEmptyValues,hasProperty} from "@/utils/refresh-cpt-data";
import 'echarts-liquidfill/src/liquidFill.js';
import {onMounted, watch, computed} from "vue";
import * as echarts from 'echarts'

const props = defineProps({
  width:Number,
  height:Number,
  option:Object,
  show:Boolean,
  components:Array,
  current: Object
})
// 新增属性兼容旧代码
const attr = props.option.attribute
if (!attr.globalDataReload) attr.globalDataReload = [0]

let dataReload = computed(() => props.option.attribute.globalDataReload || [0])
watch(() => props.current.cptShow,(val)=>{
    if (val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
  watch(() => props.option.attribute.hideCompInTabw,(val)=>{
    if (!val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })

watch(() => props.option.attribute, (obj) => {
  processData(props.option.cptDataForm,newData,jsFunFlag);
  loadChart(obj);
},{deep:true})
watch(() => [props.width,props.height], () => {
  chart.resize()
})

let uuid = require('uuid').v1();
let chartOption = {};
let chart = null
let cptData = {};
let newData = null;
let jsFunFlag = false;
const emit = defineEmits(['clickHandler'])

onMounted(()=>{
  chart = echarts.init(document.getElementById(uuid))
  if (dataReload.value.includes(0)) {
    refreshCptData();
  }
})

function refreshCptData(cptDataForm = props.option.cptDataForm,paras){
  pollingRefresh(uuid, cptDataForm, () => loadData(cptDataForm,paras),props.components)
}
function loadData(cptDataForm,paras){
  getDataJson(cptDataForm,paras,(res)=> {
        // cptData = res;
      newData = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
      jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
      processData(cptDataForm,newData,jsFunFlag);
       loadChart(props.option.attribute); 
      })
}
function processData(cptDataForm,res,jsFunFlag) {
      // 第一层判断 如果选择数据集
    if(cptDataForm.dataSource == '4') {
      // 第二层判断 ，如果没有配转换脚本
      if(jsFunFlag) { // 没有全部配置映射字段
          if(hasNonEmptyValues(props.option.attribute.cptTableData)) {
          const dataKey = props.option.attribute.cptTableData;
        // 创建一个新的数组用于存储结果
          let newres = [];
          let newObj = {...res[0]};
        // 如果dataKey中的value有值并且在newObj对象中有对应的值
          // if (dataKey[0].value && newObj[dataKey[0].value]) {
            newObj[dataKey[0].namekey] = newObj[dataKey[0].value];
          // }
          newres.push(newObj);
          // console.log(newres,'新数组');
          cptData = newres[0]; 
        }
        } else { // 如果配置了转换脚本
          cptData = res;
        }
    } else { // 不是数据集类型，是静态数据
      cptData = res;
    }
   
}
function loadChart(attr){
  let data = []
  for (let i = 0; i < attr.waveNum; i++) {
    data.push(cptData.value / 100)
  }
  chartOption = {
    series: [{
      type: 'liquidFill',
      shape: attr.shape,
      amplitude: attr.amplitude, //水波振幅
      radius: attr.radius + '%',
      label: attr.label,
      outline: {
        borderDistance: attr.outline.borderDistance,
        itemStyle: {
          borderWidth: attr.outline.borderWidth,
          borderColor: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0,
              color: attr.outline.borderColorTop
            }, {
              offset: 1,
              color: attr.outline.borderColorBottom
            }]
          },
          shadowColor: attr.outline.shadowColor,
        }
      },
      //波浪颜色
      color: [
        {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: attr.colorTop,
            },
            {
              offset: 1,
              color: attr.colorBottom,
            },
          ],
          globalCoord: false,
        },
      ],
      backgroundStyle: {
        color: {
          type: 'linear',
          x: 1,
          y: 0,
          x2: 0.5,
          y2: 1,
          colorStops: [{
            offset: 1,
            color: attr.backgroundColorTop
          }, {
            offset: 0,
            color: attr.backgroundColorBottom
          }],
        },
      },
      data: data,
    }]
  }
  chart.setOption(chartOption);
  chart.on('click', (params) => {
    emit("clickHandler",props.option.interaction,'default',params.name)
  })
}

defineExpose({refreshCptData})
</script>

<style scoped>

</style>